import React from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import svenPT from '../assets/images/svenPT.jpg';
import svenTRX from '../assets/images/svenTRX.jpg';

function AboutMe() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <SEO
        title={t('seo.aboutMe.title')}
        description={t('seo.aboutMe.description')}
        path="/aboutme"
      />
      <Navbar />

      <main className="flex-grow max-w-7xl mx-auto px-6 lg:px-12 py-12 lg:py-20">

        {/* Title */}
        <h1 className="text-3xl sm:text-4xl font-extrabold text-[#162E3B] text-center mb-12 lg:mb-16">
          {t('aboutMe.title')}
        </h1>

        {/* Section 1: Intro */}
        <div className="flex flex-col lg:flex-row gap-10 items-center mb-16 lg:mb-24">
          <div className="lg:w-1/2 text-left space-y-5">
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              {t('aboutMe.p1')}
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              {t('aboutMe.p2')}
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              {t('aboutMe.p3')}
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              {t('aboutMe.p4')}
            </p>
          </div>

          <div className="lg:w-1/2">
            <img
              className="w-full h-[360px] sm:h-[450px] object-cover rounded-2xl shadow-lg border border-gray-100"
              src={svenPT}
              alt="Trainer profile"
            />
          </div>
        </div>

        {/* Section 2: Journey & Quote */}
        <div className="flex flex-col-reverse lg:flex-row gap-10 items-center">
          <div className="lg:w-1/3">
            <img
              className="w-full h-[360px] sm:h-[500px] object-cover rounded-2xl shadow-lg border border-gray-100"
              src={svenTRX}
              alt="Trainer with TRX bands"
            />
          </div>

          <div className="lg:w-2/3 text-left space-y-5">
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              {t('aboutMe.p5')}
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              {t('aboutMe.p6')}
            </p>

            {/* Editorial Blockquote Card */}
            <div className="bg-[#162E3B]/5 border-l-4 border-[#FFD82D] p-6 rounded-r-2xl my-6">
              <p className="text-base sm:text-lg font-extrabold text-[#162E3B] italic leading-normal">
                {t('aboutMe.quote')}
              </p>
              <cite className="block text-right text-gray-500 font-bold mt-2 not-italic">{t('aboutMe.quoteAuthor')}</cite>
            </div>

            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              {t('aboutMe.p7')}
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              {t('aboutMe.p8')}
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              {t('aboutMe.p9')}
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              {t('aboutMe.p10')}
            </p>
          </div>
        </div>

      </main>

      <Footer />
    </div>
  );
}

export default AboutMe;
